import { CustomModal } from "@/components/Modal";
import { PageTitle } from "@/components/Title";
import Stack from "@mui/material/Stack";
import { Button, ButtonVariantOption, SubmitButton } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";
import { Typography } from "@mui/material";

interface IProps {
  open: boolean;
  handleClose: () => void;
  handleSubmit: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    cancelLoading: () => void
  ) => void;
  type: "owner" | "allMatters";
  timeout?: number;
}

export const ConfirmAnalyzeDialog: React.FC<IProps> = (props: IProps) => {
  const { open, handleClose, handleSubmit, type, timeout = 3000 } = props;
  const message =
    type === "owner"
      ? "所有者事項の解析を行います。"
      : "全部事項の解析を行います。";
  return (
    <CustomModal
      isOpen={open}
      handleClose={handleClose}
      ariaLabelledby="confirm-analyze-dialog"
      ariaDescribedby="confirm-analyze-dialog-description"
    >
      <Stack direction={"column"} spacing={3}>
        {/* タイトル */}
        <PageTitle>確認</PageTitle>
        {/* テキスト */}
        <Typography variant="body1">
          {message}
          <br />
          「解析する」ボタンを押すと、解析を実行し、結果一覧画面へ移動します。
          <br />
          ※解析が完了するまでお時間がかかる場合がございます。「更新」ボタンを押して最新の結果をご確認ください。
        </Typography>
        {/* ボタン */}
        <Stack
          direction={"row"}
          spacing={2}
          marginTop={2}
          justifyContent={"space-between"}
        >
          <Button
            label="閉じる"
            onClick={handleClose}
            size={SizingWrapperStyle.INHERIT}
            variant={ButtonVariantOption.Outlined}
          />
          <SubmitButton
            label="解析する"
            onClick={handleSubmit}
            size={SizingWrapperStyle.INHERIT}
            variant={ButtonVariantOption.Contained}
            timeout={timeout}
          />
        </Stack>
      </Stack>
    </CustomModal>
  );
};
